import {Injectable} from '@angular/core'
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http'
import {Observable} from 'rxjs'

import {AuthHelperService} from '@app/core/services/auth-helper.service'

@Injectable()
export class ApiAuthInterceptor implements HttpInterceptor {
  constructor(private helper: AuthHelperService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // this.logger.log('auth intercepted', req);
    // TODO check meta-attribute of request, not yet possible with current api,
    // so we rely on order to strip url part in last interceptor
    if (req.url.startsWith('api://') || req.url.indexOf('/Reports/') !== -1) {
      // set the authentication header if available
      const token: string = this.helper.token
      if (token) {
        // The core API accepts both schemes and maps either to the same user:
        //  - Keycloak/OIDC JWT  -> `Authorization: Bearer <jwt>`
        //  - legacy CURO token  -> `Authorization: CURO-TOKEN token=<id>`
        const authHeader =
          this.helper.tokenType === 'bearer'
            ? 'Bearer ' + token
            : 'CURO-TOKEN token=' + token
        req = req.clone({
          headers: req.headers.set('Authorization', authHeader),
        })
      }
    }
    return next.handle(req)
  }
}
